<template>
  <div>
    <exo-table :root="_self">
      <exo-form :root="_self">
        <template v-slot:titleTooltip>
          <exo-help-dialog
            :color="'black--text'"
            :margin="'m-0'"
            title="Earth point of interest"
          >
            A point of interest is defined by its longitude and latitude on the
            surface of the Earth.
          </exo-help-dialog>
        </template>
        <v-row>
          <v-col cols="4" class="form-column">
            <exo-input-name :root="_self" />
            <exo-input-double :root="_self" name="longitude" />
            <exo-input-double :root="_self" name="latitude" />
          </v-col>
          <v-col cols="8">
            <cesium-viewer
              v-on:locationPinned="updateInputs"
              :coordinates="{
                longitude: parseFloat(this.inputs.longitude, 10),
                latitude: parseFloat(this.inputs.latitude, 10)
              }"
            />
          </v-col>
        </v-row>
      </exo-form>
    </exo-table>
    <exo-modal-references :root="_self" :modalContent="modalRef" />
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import { mapGetters, mapActions } from 'vuex'
import dataTools from '../../tools/data'
import fieldsDescription from '../../tools/fieldsDescription'
import POIViewer from './PointOfInterestViewer.vue'
import './formsStyle.css'

export default {
  name: 'AnalyticalConstellationEarthPointOfInterest',
  components: {
    'cesium-viewer': POIViewer
  },

  mixins: [formMixin, numericalMixin],

  mounted: function () {},

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        {
          value: 'longitude',
          text: 'Longitude' + this.getDefaultUnitLabel('longitude'),
          sortable: true
        },
        {
          value: 'latitude',
          text: 'Latitude' + this.getDefaultUnitLabel('latitude'),
          sortable: true
        },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      modalRef: { content: [] },
      showModal: false,

      enumPropertiesList: this.getEnumProperties(),

      inputs: {
        longitude: this.getDefaultValue('longitude'),
        latitude: this.getDefaultValue('latitude')
      }
    }
  },

  methods: {
    ...mapActions(['setCurrentMission']),

    getObjectSubType(instance) {
      return null
    },

    getRequiredPropertiesList(instance) {
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        this.getObjectSubType(instance),
        'required'
      )
    },

    getOptionalPropertiesList(instance) {
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        this.getObjectSubType(instance),
        'optional'
      )
    },

    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },

    getCurrentFormTitle() {
      return 'Point Of Interest'
    },

    getCurrentFormType() {
      return 'PointOfInterestDefinition'
    },
    updateInputs(cartoPos) {
      this.inputs.longitude = cartoPos.longitude
      this.inputs.latitude = cartoPos.latitude
    }
  },
  computed: {
    ...mapGetters(['currentMission'])
  }
}
</script>
